import MoreOutlined from '@ant-design/icons/MoreOutlined';
import Button from 'antd/es/button';
import Dropdown from 'antd/es/dropdown';
import type { MenuProps } from 'antd/es/menu';
import React from 'react';

export interface ActionItem {
  key: string;
  label: string;
  icon?: React.ReactNode;
  danger?: boolean;
  disabled?: boolean;
  onClick?: () => void;
}

export interface ActionDropdownProps {
  actions: (ActionItem | { type: 'divider' })[];
  trigger?: ('click' | 'hover')[];
  placement?: 'bottomLeft' | 'bottomRight' | 'topLeft' | 'topRight';
  disabled?: boolean;
  loading?: boolean;
}

export const ActionDropdown: React.FC<ActionDropdownProps> = ({
  actions,
  trigger = ['click'],
  placement = 'bottomRight',
  disabled = false,
  loading = false,
}) => {
  const menuItems: MenuProps['items'] = actions.map((action, index) => {
    if ('type' in action && action.type === 'divider') {
      return { type: 'divider' as const, key: `divider-${index}` };
    }

    const menuItem = action as ActionItem;
    return {
      key: menuItem.key,
      label: menuItem.label,
      icon: menuItem.icon,
      danger: menuItem.danger,
      disabled: menuItem.disabled,
      onClick: menuItem.onClick,
    };
  });

  return (
    <Dropdown
      menu={{ items: menuItems }}
      trigger={trigger}
      placement={placement}
      disabled={disabled}
    >
      <Button
        type="text"
        icon={<MoreOutlined />}
        loading={loading}
        disabled={disabled}
        style={{ width: 32, height: 32 }}
      />
    </Dropdown>
  );
};

export default ActionDropdown;
